module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate20.49f98c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate20.png
// module id = 756
// module chunks = 0